const SPOTS = [["home", "Homepage"], ["directory", "Directory home"], ["results", "Directory search results"], ["pricing", "Pricing page"]];
const inp = "h-9 w-full border border-slate-300 rounded-md px-2 text-sm";

export const BannerPlacement = ({ form, setForm }) => {
  const on = form.placements || ["home"];
  const flip = (k) => setForm({ ...form, placements: on.includes(k) ? on.filter(x => x !== k) : [...on, k] });
  return (
    <div className="space-y-3" data-testid="banner-placement">
      <div><p className="text-sm font-medium mb-1">Show on</p>
        <div className="grid grid-cols-2 gap-1.5">{SPOTS.map(([k, l]) => <label key={k} className="flex items-center gap-2 text-sm"><input type="checkbox" checked={on.includes(k)} onChange={() => flip(k)} data-testid={`banner-spot-${k}`} />{l}</label>)}</div>
        {!on.length && <p className="text-xs text-red-600 mt-1">Pick at least one place.</p>}</div>
      <div className="grid grid-cols-2 gap-3">
        <label className="text-sm space-y-1"><span className="block font-medium">Start date (optional)</span><input type="date" value={form.starts || ""} onChange={e => setForm({ ...form, starts: e.target.value })} className={inp} data-testid="banner-starts" /></label>
        <label className="text-sm space-y-1"><span className="block font-medium">End date (optional)</span><input type="date" value={form.ends || ""} onChange={e => setForm({ ...form, ends: e.target.value })} className={inp} data-testid="banner-ends" /></label></div>
      <p className="text-xs text-slate-500">Several banners in the same spot rotate every few seconds. A link starting with / opens a page on this site; https:// links open in a new tab.</p>
    </div>
  );
};

export const spotLabel = (b) => {
  const names = (b.placements || ["home"]).map(k => (SPOTS.find(s => s[0] === k) || [k, k])[1]).join(", ");
  const when = b.starts || b.ends ? ` · ${b.starts || "now"} → ${b.ends || "no end"}` : "";
  return names + when;
};
